export class FastForwardInfoModel {
    constructor() {}
    resetDataModel = function () {};
}
